// Auto-generated by vibesites deploy pipeline. Do not edit manually.
// Includes inherited overrides from: core -> theme-avneue-no-vendor -> repli-sandbox-avneue-no-vendor -> hilltops
// Generated: 2026-10-05T18:31:59.867Z
// Counts: 2 design, 15 content, 21 slot group, 0 collection binding, 3 section, 0 style

export const designOverrides = {
  "design._site.color.primary": {
    "cssVariable": "--vibe-color-primary",
    "overrideType": "VALUE",
    "value": "#7c868d",
    "mappedField": null
  },
  "design._site.color.secondary": {
    "cssVariable": "--vibe-color-secondary",
    "overrideType": "FIELD_MAPPING",
    "value": null,
    "mappedField": "property_font_color"
  }
};

export const contentOverrides = {
  "apartment-sync.javascript_id": {
    "overrideType": "VALUE",
    "customValue": "asdfasdfasdf",
    "generatedValue": null,
    "mappedField": null
  },
  "propertyoverview.title": {
    "overrideType": "VALUE",
    "customValue": "110 Royyyyy",
    "generatedValue": null,
    "mappedField": null
  },
  "amenitycardgrid.subheading": {
    "overrideType": "VALUE",
    "customValue": "<p>From resort-style mornings by the pool to quiet evenings along the lakeside paths, every shared space at Hilltops is designed to help you relax, connect, and feel at home. Explore the amenities that make life here effortless.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "featuredamenities.apartmentBlurbSubtitle": {
    "overrideType": "VALUE",
    "customValue": "<p>Refined touches in every room</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "featuredamenities.apartmentBlurbText": {
    "overrideType": "VALUE",
    "customValue": "<p>Step inside to dramatic ceilings, warm designer finishes, and details chosen to make everyday living feel a little more special. From the kitchen to the garden tub, your Hilltops home blends vintage charm with the modern comforts you'll look forward to coming back to.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "featuredamenities.apartmentBlurbTitle": {
    "overrideType": "VALUE",
    "customValue": "<p>Comfort, Thoughtfully Designed</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "featuredamenities.communityBlurbSubtitle": {
    "overrideType": "VALUE",
    "customValue": "<p>Where nature and neighbors meet</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "featuredamenities.communityBlurbText": {
    "overrideType": "VALUE",
    "customValue": "<p>Wind down along the walking paths that trace our two scenic lakes, then gather poolside or around the fire pit as the Conroe evening settles in. Every shared space at Hilltops is made for slowing down, connecting, and feeling at home in the heart of nature.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "featuredamenities.communityBlurbTitle": {
    "overrideType": "VALUE",
    "customValue": "<p>Life by the Lakes</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "featuredamenities.subheading": {
    "overrideType": "VALUE",
    "customValue": "<p>From our resort-style pool to the scenic lakes winding through the community, every detail at Hilltops is designed to help you relax, recharge, and feel right at home. Take a closer look at the amenities that make everyday living here something special.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "gallery.apartment_blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Our spacious one- and two-bedroom homes are designed for comfortable living, featuring chef-inspired kitchens with granite countertops, designer cabinetry, and black or stainless-steel appliances. Dramatic 9-foot or vaulted ceilings, plank flooring, and oval garden tubs add a touch of elegance, while private balconies and patios invite you to take in the surrounding natural views. Choose from layouts ranging from 724 to 1,239 square feet to find the home that fits your lifestyle.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "gallery.community_blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Set in a garden-style community near Lake Conroe, Hilltops brings nature right to your door with two scenic on-property lakes and walking paths. Spend sunny afternoons by the resort-style pool, gather friends at the fire pit and outdoor gas kitchen, or let your dog run at the bark park. With controlled-access gates, a 24-hour fitness center, and a car wash on site, everyday convenience meets easygoing Texas charm.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "hero.learn_more": {
    "overrideType": "VALUE",
    "customValue": "<p>Set in the heart of Conroe, Texas, <span data-type=\"field-token\" data-field=\"property_name\"></span> pairs vintage character with modern comforts across spacious one- and two-bedroom homes ranging from 724 to 1,239 square feet. Residents enjoy standout amenities including a resort-style pool, a 24-hour fitness center, scenic lakes with walking paths, a dog park, and a clubroom with billiards. Chef-inspired kitchens, granite countertops, and private balconies bring everyday luxury home, while controlled-access gates and on-site maintenance keep life easy and secure. Explore our floor plans or schedule a tour to find the home that fits your lifestyle.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "hero.romance_blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>weeoeoo</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "petpolicy.intro": {
    "overrideType": "VALUE",
    "customValue": "<p>At Hilltops, your whole family is welcome — including the four-legged members. Set among two scenic lakes and lush green grounds near Lake Conroe, our community gives pets plenty of room to roam, including an on-site dog park with agility equipment for play and exercise.</p>",
    "generatedValue": null,
    "mappedField": null
  }
};

export const slotGroupOverrides = {
  "amenitycardgrid.card_1": {
    "sourceIndex": null,
    "fieldOverrides": {
      "alt": {
        "type": "VALUE",
        "customValue": "Outdoor patio seating with blue couches and yellow pillows overlooking a swimming pool and apartment buildings."
      },
      "title": {
        "type": "VALUE",
        "customValue": "Resort-Style Pool"
      },
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449162890/019cfddc-301b-7652-a57f-910dec3c120e.webp"
      },
      "description": {
        "type": "VALUE",
        "customValue": "Soak up the Texas sun from designer lounge furniture or take a refreshing dip — our resort-style pool is the perfect place to unwind and gather with neighbors."
      }
    }
  },
  "amenitycardgrid.card_2": {
    "sourceIndex": null,
    "fieldOverrides": {
      "alt": {
        "type": "VALUE",
        "customValue": "Car wash and air station at multifamily property."
      },
      "title": {
        "type": "VALUE",
        "customValue": "Car Wash & Vacuum"
      },
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449162890/019cfddc-31ce-75a3-80a7-c90fb168fded.webp"
      },
      "description": {
        "type": "VALUE",
        "customValue": "Keep your ride spotless without ever leaving home, thanks to our on-site car wash and vacuum station — convenience built right into your everyday routine."
      }
    }
  },
  "amenitycardgrid.card_3": {
    "sourceIndex": null,
    "fieldOverrides": {
      "alt": {
        "type": "VALUE",
        "customValue": "Conference room with a large table, chairs, and multiple TVs."
      },
      "title": {
        "type": "VALUE",
        "customValue": "Clubroom & Billiards"
      },
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449162890/019cfddc-7549-762f-b62d-717d20b122bd.webp"
      },
      "description": {
        "type": "VALUE",
        "customValue": "Host friends over a game of billiards or settle in for resident events in our welcoming clubroom — a comfortable space made for connection and good company."
      }
    }
  },
  "amenitycardgrid.card_4": {
    "sourceIndex": null,
    "fieldOverrides": {
      "alt": {
        "type": "VALUE",
        "customValue": "Spacious communal living area with a large sectional sofa, armchairs, coffee table, and entertainment center."
      },
      "title": {
        "type": "VALUE",
        "customValue": "Cappuccino Bar"
      },
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449162890/019cfddb-f894-7505-95b4-3b453571e79a.webp"
      },
      "description": {
        "type": "VALUE",
        "customValue": "Start your morning with a freshly brewed cappuccino and a cozy seat in our resident lounge — a warm welcome to ease you into the day."
      }
    }
  },
  "ctasection.card1_image": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449162890/019cfddc-125a-712d-961d-819a0013d0c0.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Bedroom with a queen-size bed, navy and white pillows, and gray curtains."
      }
    }
  },
  "ctasection.card2_image": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449162890/019d4f32-de60-732f-9ed7-d0621fae785f.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Exterior aerial view of apartment buildings surrounded by trees."
      }
    }
  },
  "ctasection.card3_image": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449162890/019cfddc-3fec-750d-a9f7-3d1261b34d1c.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Apartment buildings with a pond and fountain."
      }
    }
  },
  "ctasection.card4_image": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449162890/019cfddc-2187-742f-8b72-63b4d4998b4a.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Resort-style swimming pool with lounge chairs and palm trees."
      }
    }
  },
  "featuredamenities.card_1": {
    "sourceIndex": null,
    "fieldOverrides": {
      "alt": {
        "type": "VALUE",
        "customValue": "Resort-style swimming pool with lounge chairs and palm trees."
      },
      "title": {
        "type": "VALUE",
        "customValue": "Resort-Style Pool"
      },
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449162890/019cfddc-2187-742f-8b72-63b4d4998b4a.webp"
      },
      "description": {
        "type": "VALUE",
        "customValue": "Soak up the sun on designer lounge furniture or cool off with a refreshing dip in our sparkling resort-style pool. It's your own private retreat, just steps from home."
      }
    }
  },
  "featuredamenities.card_2": {
    "sourceIndex": null,
    "fieldOverrides": {
      "alt": {
        "type": "VALUE",
        "customValue": "Treadmills, ellipticals, stationary bikes, and weightlifting equipment in a modern apartment complex gym."
      },
      "title": {
        "type": "VALUE",
        "customValue": "24-Hour Fitness Center"
      },
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449162890/019cfddc-772a-7105-9e57-ef40eea5b5b5.webp"
      },
      "description": {
        "type": "VALUE",
        "customValue": "Stay strong and energized on your own schedule in our modern 24-hour fitness center, stocked with cardio machines and free weights. A great workout is always just an elevator ride away."
      }
    }
  },
  "featuredamenities.card_3": {
    "sourceIndex": null,
    "fieldOverrides": {
      "alt": {
        "type": "VALUE",
        "customValue": "Apartment buildings with a pond and fountain."
      },
      "title": {
        "type": "VALUE",
        "customValue": "Scenic Lakes & Walking Paths"
      },
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449162890/019cfddc-3fec-750d-a9f7-3d1261b34d1c.webp"
      },
      "description": {
        "type": "VALUE",
        "customValue": "Stroll the walking paths around two scenic lakes and let the fountains and natural beauty melt the day away. Lakeside serenity is part of everyday life at Hilltops."
      }
    }
  },
  "featuredamenities.card_4": {
    "sourceIndex": null,
    "fieldOverrides": {
      "alt": {
        "type": "VALUE",
        "customValue": "Dog park with play equipment and apartment buildings in the background."
      },
      "title": {
        "type": "VALUE",
        "customValue": "Bark Park"
      },
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449162890/019cfddc-7668-705d-bd16-d29d227b93fb.webp"
      },
      "description": {
        "type": "VALUE",
        "customValue": "Let your furry friend run, play, and socialize in our spacious bark park, complete with agility equipment and plenty of green space. Here, every member of the family feels at home."
      }
    }
  },
  "gallery.hero_1": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449162890/019cfddc-4e4f-700c-8670-1495a8da0e76.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Aerial view of a resort-style swimming pool with lounge chairs and palm trees."
      }
    }
  },
  "gallery.hero_2": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449162890/019cfddc-3fec-750d-a9f7-3d1261b34d1c.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Apartment buildings with a pond and fountain."
      }
    }
  },
  "gallery.hero_3": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449162890/019cfddc-22b2-77c5-b815-ceb5b65437d5.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Spacious lobby with a stone fireplace, plush seating, and elegant decor."
      }
    }
  },
  "petpolicy.feature_image": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449162890/019cfddc-7668-705d-bd16-d29d227b93fb.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Dog park with play equipment and apartment buildings in the background."
      }
    }
  },
  "petpolicy.lifestyle_image": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449162890/019cfddc-3fec-750d-a9f7-3d1261b34d1c.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Apartment buildings with a pond and fountain."
      }
    }
  },
  "propertyoverview.feature_image_1": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449162890/019cfddc-08cf-75bb-ac37-50b32e182ff2.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Modern kitchen with dark wood cabinets, stainless steel appliances, granite countertops, and hardwood floors."
      }
    }
  },
  "propertyoverview.feature_image_2": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449162890/019cfddc-772a-7105-9e57-ef40eea5b5b5.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Treadmills, ellipticals, stationary bikes, and weightlifting equipment in a modern apartment complex gym."
      }
    }
  },
  "propertyoverview.feature_image_3": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449162890/019cfddc-22b2-77c5-b815-ceb5b65437d5.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Spacious lobby with a stone fireplace, plush seating, and elegant decor."
      }
    }
  },
  "propertyoverview.feature_image_4": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449162890/019cfddc-7668-705d-bd16-d29d227b93fb.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Dog park with play equipment and apartment buildings in the background."
      }
    }
  }
};

export const collectionBindingOverrides = {};

export const sectionOverrides = {
  "_global": [
    {
      "sectionId": "google-tag-manager",
      "blockId": "google-tag-manager",
      "position": 0
    },
    {
      "sectionId": "json-ld-schema",
      "blockId": "json-ld-schema",
      "position": 0
    }
  ],
  "floor-plans": [
    {
      "sectionId": "apartment-sync",
      "blockId": "apartment-sync",
      "position": 3
    }
  ]
};

export const styleOverrides = {};
